var isMobile = window.innerWidth <= 980;

var imagesList = document.querySelectorAll("#main-content img");


for (var tempIndex = 0; tempIndex < imagesList.length; tempIndex++) {
  var tempImage = imagesList[tempIndex];
  if (!tempImage.getAttribute("src")) {
    tempImage.setAttribute(
      "src",
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    );
  }
}



window.hasTriggered = window.hasTriggered || false;
    
function countTo(el, to = 44, duration = 2000, from = 87) {
      const start = performance.now();

      // 三种颜色
      const colors = ["red", "orange", "#4AD28C"];

      // 缓动函数 - 先快后慢 (ease-out)
      function easeOut(t) {
        return 1 - Math.pow(1 - t, 2); 
      }

      function frame(now) {
        const elapsed = now - start;
        const linearProgress = Math.min(elapsed / duration, 1);
        
        // 应用缓动函数
        const easedProgress = easeOut(linearProgress);

        // 数字插值 (从大到小，使用缓动进度)
        const value = Math.floor(from - (from - to) * easedProgress);
        el.textContent = value;

        // 根据数字范围选择颜色 (平均分配)
        let colorIndex;
        
        if (value >= 73) colorIndex = 0;      // 73-87: 红色
        else if (value >= 59) colorIndex = 1; // 59-72: 橙色  
        else colorIndex = 2;                  // 44-58: 绿色

        el.style.color = colors[colorIndex];

        if (linearProgress < 1) {
          requestAnimationFrame(frame);
        }
      }

      requestAnimationFrame(frame);
}

// 创建 Intersection Observer 监听元素是否进入视口
function createScrollTrigger() {
      const el = document.getElementById('counter');
      const counterSection = document.querySelector('.counter-section');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasTriggered) {
            hasTriggered = true;
            countTo(el, 44, 2000, 87);
            console.log('滚动触发倒计时');
          }
        });
      }, {
        threshold: 0.5 // 当元素50%可见时触发
      });

      observer.observe(counterSection);
      return observer;
}


    function openVideoModal() {
        const modal = document.getElementById('videoModal');
        const iframe = document.getElementById('videoFrame');
        
        // 设置视频源
        iframe.src = 'https://player.vimeo.com/video/1097783873?badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1';                     
        
        // 显示弹窗
        modal.classList.add('active');
        
        // 禁止页面滚动
        document.body.style.overflow = 'hidden';
    }

    function closeVideoModal(event) {
        // 如果点击的是容器本身（而不是视频），则关闭弹窗
        if (event && event.target !== event.currentTarget) {
            return;
        }
        
        const modal = document.getElementById('videoModal');
        const iframe = document.getElementById('videoFrame');
        
        // 停止视频播放
        iframe.src = '';
        
        // 隐藏弹窗
        modal.classList.remove('active');
        
        // 恢复页面滚动
        document.body.style.overflow = 'auto';
    }

    // 按ESC键关闭弹窗
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeVideoModal();
        }
    }); 


function wapPageInit() {

  //注册图片懒加载
  new LazyLoad({
    elements_selector: "#main-content img",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    threshold: "3000",
    callback_enter: function (element) { },
  });
  
  new LazyLoad({
    elements_selector: "#main-content video",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    data_poster: "cbcn-poster",
    threshold: "3000",
    callback_enter: function (element) { },
  });

  // 移动端横屏问题
  var refreshTimer = null;
  // 或者监听设备方向的变化
  window.addEventListener("orientationchange", () => {
    // let orientation = screen.orientation || window.orientation;
    // if (orientation.type.includes('portrait')) {
    //   // 竖屏
    //   console.log('现在是竖屏');
    // } else if (orientation.type.includes('landscape')) {
    //   // 横屏
    //   console.log('现在是横屏');
    // }

    refreshTimer = this.clearTimeout(refreshTimer);
    setTimeout(ScrollTrigger.refresh, 200);
  });



  // 02 begin

new Swiper('.charintro', {
            // Optional parameters
            centeredSlides: true,
            effect: 'slide',
            speed: 800,
            
            // Responsive breakpoints
            breakpoints: {
                // When window width is >= 768px
                768: {
                    slidesPerView: 1,
                    spaceBetween: 15
                },
                // When window width is >= 1024px
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 60
                }
            },

            // Pagination
            pagination: {
                el: '.charintro-pagination',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.charintro-next',
                prevEl: '.charintro-prev',
            },

});

  // 02 end


  // 06 begin

  new Swiper('.t1-power', {
              // Optional parameters
              centeredSlides: true,
              effect: 'slide',
              speed: 800,
              
              // Responsive breakpoints
              breakpoints: {
                  // When window width is >= 768px
                  768: {
                      slidesPerView: 1,
                      spaceBetween: 30
                  },
                  // When window width is >= 1024px
                  1024: {
                      slidesPerView: 1,
                      spaceBetween: 40
                  }
              },

              // Pagination
              pagination: {
                  el: '.t1-power-pagination',
                  clickable: true,
                  dynamicBullets: false,
              },

              // Navigation arrows
              navigation: {
                  nextEl: '.t1-power-next',
                  prevEl: '.t1-power-prev',
              },

  });

  // 06 end


  // 12 begin

new Swiper('.t1-nozzle', {
            // Optional parameters
            centeredSlides: true,
            effect: 'slide',
            speed: 800,
            
            // Responsive breakpoints
            breakpoints: {
                // When window width is >= 768px
                768: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                // When window width is >= 1024px
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 40
                }
            },

            // Pagination
            pagination: {
                el: '.t1-nozzle-pagination',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.t1-nozzle-next',
                prevEl: '.t1-nozzle-prev',
            },

});

  // 12 end


  // 14 begin

    // 初始化 Swiper - 比较轮播
    const h1comparisonswiper = new Swiper('.h1comparison-swiper', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        effect: 'slide',
        speed: 600,
        on: {
            slideChange: function () {
                // 更新选项卡按钮状态
                tabButtonsA.forEach((button, index) => {
                    if (index === this.activeIndex) {
                        button.classList.add('active');
                    } else {
                        button.classList.remove('active');
                    }
                });
                
                // 控制比较轮播中的视频播放
                const comparisonVideos = document.querySelectorAll('.h1comparison-swiper video');
                comparisonVideos.forEach((video, idx) => {
                    if (idx === this.activeIndex) {
                        video.play();
                    } else {
                        video.pause();
                    }
                });
            },
        }
    });

    // 获取比较轮播的选项卡按钮
    const tabButtonsA = document.querySelectorAll('.h1comparison-tab-button');

    // 比较轮播选项卡点击事件
    tabButtonsA.forEach((button, index) => {
        button.addEventListener('click', () => {
            // 切换到对应幻灯片
            h1comparisonswiper.slideTo(index);
            
            // 更新按钮状态
            tabButtonsA.forEach((btn, idx) => {
                if (idx === index) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });
        });
    });

  // 14 end


  // 15 begin

new Swiper('.t1-store', {
            // Optional parameters
            centeredSlides: true,
            effect: 'slide',
            speed: 800,
            
            // Responsive breakpoints
            breakpoints: {
                // When window width is >= 768px
                768: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                // When window width is >= 1024px
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 40
                }
            },

            // Pagination
            pagination: {
                el: '.t1-store-pagination',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.t1-store-next',
                prevEl: '.t1-store-prev',
            },

});

  // 15 end


createScrollTrigger();





}

if (isMobile) {
  window.onload = function () {
    // 使用原生JavaScript替换jQuery的remove方法
    var loadingElements = document.querySelectorAll(".loadingWt");
    loadingElements.forEach(function(element) {
      element.remove();
    });

    wapPageInit();
  };
}